<template>
  <b-dropdown
    v-if="hasMultipleOptions"
    :variant="variant"
    :size="size"
    :text="$t('navbar.new_realisation_process')"
    right
    split
    @click="handleStartUnspecifiedType"
  >
    <b-dropdown-item-button
      v-for="option in getOptions"
      :key="option.value"
      @click="handleStartWithType({ type: option })"
    >
      <div class="d-flex justify-content-between">
        <div>{{ option.text }}</div>
        <i class="fa-fw fal fa-plus ml-1" />
      </div>
    </b-dropdown-item-button>
  </b-dropdown>

  <b-button
    v-else
    :variant="variant"
    :size="size"
    class="processbtn"
    @click="handleStartSingleType"
  >
    {{ $t('navbar.new_realisation_process') }} <i class="fa-fw fal fa-plus ml-1" />
  </b-button>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'StartProcessButton',
  props: {
    context: {
      type: String,
      default: null,
    },
    variant: {
      type: String,
      default: 'primary',
    },
    size: {
      type: String,
      default: null,
    },
    query: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters('tenant', ['getCategoryOptionsByContext']),
    getOptions() {
      return this.getCategoryOptionsByContext({
        context: this.context,
      })
    },
    hasMultipleOptions() {
      return this.getOptions.length > 1
    },
  },
  methods: {
    handleStartSingleType() {
      let options = this.getOptions
      if (!options.length) {
        this.handleStartUnspecifiedType()
      } else {
        this.handleStartWithType({
          type: options[0],
        })
      }
    },
    handleStartUnspecifiedType() {
      let route = {
        name: process.env.VUE_APP_TENANT === 'rvb' ? 'new-private' : 'NewRealisation',
      }
      if (this.query) {
        route.query = this.query
      }
      this.$router.push(route)
    },
    handleStartWithType({ type }) {
      let route = {
        name: 'NewRealisationType',
        params: {
          type: type.value,
        },
      }
      if (this.query) {
        route.query = this.query
      }
      this.$router.push(route)
    },
  },
}
</script>

<style>
.processbtn {
  display: flex;
  align-items: center;
}
</style>
